import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { ReportsService } from 'src/app/services/reports.service';
import { ListaPulsantiMercatiComponent } from "../shared/lista-pulsanti-mercati/lista-pulsanti-mercati.component";

@Component({
  selector: 'app-analisi-ts',
  standalone: true,
  templateUrl: './analisi-ts.component.html',
  styleUrls: ['./analisi-ts.component.scss'],
  imports: [CommonModule, MdbSelectModule, ReactiveFormsModule, ListaPulsantiMercatiComponent]
})
export class AnalisiTsComponent implements OnInit {

  //@ViewChild('centralFluid', { static: true }) centralFluid: ModalDirective;

  loader: boolean = true;
  grafico: boolean = true
  titoloGrafico = ''
  public chart1Type = 'line';

  public chartDatasets: Array<any> = [];
  chart1Labels: Array<any> = [];
  public chartColors: Array<any> = [
    {
      backgroundColor: 'rgba(220,220,220,0.2)',
      borderColor: 'rgba(220,220,220,1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(220,220,220,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(220,220,220,1)'
    },
    {
      backgroundColor: 'rgba(151,187,205,0.2)',
      borderColor: 'rgba(151,187,205,1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(151,187,205,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(151,187,205,1)'
    }
  ];



  public chartOptions: any = {
    responsive: true
  };

  updateOK: boolean = false;
  updateKO: boolean = false;

  tableData: Array<any> = []
  listaCompleta = []
  chartDati: any

  selMarkets: any[] = [
  ];
  weekDays = [
    { value: '2', label: 'Lunedi' },
    { value: '3', label: 'Martedi' },
    { value: '4', label: 'Mercoledi' },
    { value: '5', label: 'Giovedi' },
    { value: '6', label: 'Venerdi' }
  ]
  showOnlyOptionsSelect: any[] = this.weekDays;

  orari: Array<number> = []
  selGiorno = new UntypedFormControl()
  selMercato = new UntypedFormControl()
  selOrario = new UntypedFormControl()
  selPattern = new UntypedFormControl()
  selNumop = new UntypedFormControl()
  mima = new UntypedFormControl()
  percpos = new UntypedFormControl()
  mima2 = new UntypedFormControl()
  puntiop = new UntypedFormControl()

  sorted: any

  numop: Array<number> = []

  ultimovalore: string = ''
  tipopattern: string = ''
  idm = 0
  updatingMarket = ''
  updateRunning = false

  colMarket: boolean = true
  colPattern: boolean = false
  colGiorno: boolean = true

  btnUSD: Array<any> = []
  btnEUR: Array<any> = []
  btnGBP: Array<any> = []
  btnCross: Array<any> = []
  btnIndex: Array<any> = []
  btnOthers: Array<any> = []

  rifUV: number = 0
  ideaTrading = false
  levelBuy = 0
  tpBuy = 0
  slBuy = 0
  rrBuy = 0
  levelSell = 0
  tpSell = 0
  slSell = 0
  rrSell = 0

  constructor(private service: ReportsService) { }

  ngOnInit(): void {

    for (let i: number = 0; i < 22; i++) {
      this.orari.push(i)
      this.numop.push(i)
    }
    this.service.getMarkets().subscribe((res: any) => {
      if (res['res'] == 'ok') {
        this.selMarkets = res['data']
        let mm = res['data']
        this.btnUSD = mm.filter((m: any) => m.tipo == 'Major')
        mm = mm.filter((m: any) => {
          let t = this.btnUSD.find((m1: any) => {
            return m1.market == m.market
          })
          return t == undefined ? true : false
        }
          , this.btnUSD)
        this.btnEUR = mm.filter((m: any) => {
          return m.market.includes('EUR')
        })
        mm = mm.filter((m: any) => {
          let t = this.btnEUR.find((m1: any) => {
            return m1.market == m.market
          })
          return t == undefined ? true : false
        }
          , this.btnEUR)
        this.btnGBP = mm.filter((m: any) => {
          return m.market.includes('GBP')
        })

        mm = mm.filter((m: any) => {
          let t = this.btnGBP.find((m1: any) => {
            return m1.market == m.market
          })
          return t == undefined ? true : false
        }
          , this.btnGBP)

        this.btnCross = mm.filter((m: any) => m.tipo == 'Cross')
        this.btnIndex = mm.filter((m: any) => m.tipo == 'Index')
        this.btnOthers = mm.filter((m: any) => m.tipo == 'Altri')

        // this.selMarkets.unshift({ market: 'Tutti' })
        this.selMercato.setValue('Tutti')
        this.selPattern.setValue('Tutti')
      }
    })
      this.selPattern.valueChanges.subscribe(pp => {
        //this.colPattern = (this.selPattern.value == 0 || this.selPattern.value == "Tutti") ? true : false
        let gg = this.weekDays.find(item => item.value == this.selGiorno.value, this.selGiorno.value)
        this.tableData = this.filtraDati(this.selMercato.value, gg ? gg.value : undefined, this.selOrario.value, this.selPattern.value, this.selNumop.value).slice(0, 100)
      })
      this.selGiorno.valueChanges.subscribe((gg: number) => {
        this.colGiorno = this.selGiorno.value == 0 ? true : false
        let gg2 = this.weekDays.find(item => item.value == this.selGiorno.value, this.selGiorno.value)
        this.tableData = this.filtraDati(this.selMercato.value, (gg2 ? gg2.value : undefined), this.selOrario.value, this.selPattern.value, this.selNumop.value).slice(0, 100)
      })
      this.selMercato.valueChanges.subscribe(mkt => {
        this.colMarket = this.selMercato.value == "Tutti" ? true : false
        let gg = this.weekDays.find(item => parseInt(item.value) == this.selGiorno.value, this.selGiorno.value)
        this.tableData = this.filtraDati(mkt, (gg ? gg.value : undefined), this.selOrario.value, this.selPattern.value, this.selNumop.value).slice(0, 100)
      })
      this.selOrario.valueChanges.subscribe(ora => {
        let gg = this.weekDays.find(item => item.value == this.selGiorno.value, this.selGiorno.value)
        this.tableData = this.filtraDati(this.selMercato.value, (gg ? gg.value : undefined), ora, this.selPattern.value, this.selNumop.value).slice(0, 100)
      })
      this.caricaLista()
  }

  applicaFiltri() {

  }
  /* 
    apriGrafico(titolo, day, pattern, orap, oraclose){
      this.service.report_market(titolo, day, pattern, orap, oraclose).subscribe(result=>{
        console.log(result)
        let profit = []
        let last = 0
        result['data'].forEach((item)=>{
          last += parseFloat(item.profit)
          profit.push(last)
        })
        this.chartDatasets = [{data: profit, label: 'Equity'}]
        this.chart1Labels = result['data'].map((item)=>{
          return item.orap.substring(0,10)
        })
        this.titoloGrafico = titolo
        this.chartDati = result['data']
        this.centralFluid.show()
      })
    } */

  vediDati() {
    this.grafico = false
  }
  vediGrafico() {
    this.grafico = true
  }

  selMarket2(mkt: any) {
    console.log(mkt)
    this.selMarket(mkt.market)
  }

  apriGrafico(mkt: string, giorno: string, pattern: string, orap: number, oraclosep: number) {
  }

  selMarket(mkt: any) {
    if (mkt == '' || mkt == 'tutti') { return }
    if (this.selMercato.value != mkt) {
      this.selMercato.setValue(mkt)
    }
    this.service.lastValues(mkt, this.selOrario.value).subscribe((result: any) => {
      if (result['res'] == 'ok') {
        if (result['data'].length > 0) {
          let val = result['data'][0].vclose - result['data'][result['data'].length - 1].vopen
          this.ultimovalore = result['data'][result['data'].length - 1].ora + ' ' + result['data'][0].vclose
          this.rifUV = parseFloat(result['data'][0].vclose)
          this.tipopattern = val > 0 ? "Pattern A" : "Pattern B"
        } else {
          this.ultimovalore = 'Dato non trovato per l\'ora attuale'
          this.rifUV = 0
          this.tipopattern = ''
        }
      } else {
        //console.log(result)
      }
      if(this.rifUV > 0)
        this.suggerimento()
    })
  }

  suggerimento() {
    this.ideaTrading = true
    let maxDD = this.tableData.reduce((prev, item) => parseFloat(prev.avghighpos) > parseFloat(item.avghighpos) ? prev : item)
    this.levelBuy = this.rifUV - (+maxDD.avghighpos * 0.8)
    let maxRU = this.tableData.reduce((prev, item) => parseFloat(prev.avglowpos) > parseFloat(item.avglowpos) ? prev : item)
    this.tpBuy = this.rifUV - +maxDD.avghighpos + +maxRU.avglowpos
    this.slBuy = this.rifUV - (+maxDD.avghighpos * 1.2)
    this.rrBuy = (this.tpBuy - this.levelBuy) / (this.levelBuy - this.slBuy)
    maxDD = this.tableData.reduce((prev, item) => parseFloat(prev.avglowneg) > parseFloat(item.avglowneg) ? prev : item)
    this.levelSell = this.rifUV + (+maxDD.avglowneg * 0.8)
    maxRU = this.tableData.reduce((prev, item) => parseFloat(prev.avghighneg) > parseFloat(item.avghighneg) ? prev : item)
    this.tpSell = this.rifUV + +maxDD.avglowneg - +maxRU.avghighneg
    this.slSell = this.rifUV + (+maxDD.avglowneg * 1.2)
    this.rrSell = (this.levelSell - this.tpSell) / (this.slSell - this.levelSell)
    /* if(this.rifUV>0){
    }else{
      this.ideaTrading = false
    } */
  }

  aggiorna_pp_m12() {
    this.idm = 0
    this.updateKO = false
    this.updateOK = false
    this.updateM12(this.selMarkets[this.idm].market, true)
  }

  updateM12(mkt: any, deleteAll: boolean = false) {
    if (mkt.toLowerCase() == 'tutti') {
      this.idm++
      this.updateM12(this.selMarkets[this.idm].market, deleteAll)
      return
    }
    this.updateRunning = true
    this.updatingMarket = mkt
    this.service.updateReports_pp_m12(mkt, deleteAll)
      .subscribe((data: any) => {
        if (data['res'] == 'ko') {
          this.updateKO = true
          console.log(data)
        } else {
          console.log(data)
          this.idm += 1
          if (this.idm == this.selMarkets.length) {
            this.updateRunning = false
            this.updateOK = true
            this.caricaLista()
            return
          } else {
            this.updateM12(this.selMarkets[this.idm].market)
          }
        }
      },
        err => {
          if (window.location.hostname.indexOf('localhost') < 0) {
            console.log('orrore', err)
          } else {
            alert(JSON.stringify(err))
          }
        })
  }

  addPref(id: any) {
    this.service.addPref(id).subscribe((data: any) => {
      console.log(data)
      let el: any = this.listaCompleta.find((item:any) => {
        return item.id == id
      }, id)
      el.id_rep = data['id']
      let el2 = this.tableData.find(item => {
        return item.id == id
      }, id)
      el2.id_rep = data['id']
    })
  }

  caricaLista() {
    this.loader = true
    this.service.report_m12()
      .subscribe((data: any) => {
        if (data['res'] == 'ko') {
          console.log(data)
        } else {
          console.log(data)
          this.listaCompleta = data['data']
          this.tableData = this.listaCompleta.slice(0, 100)
        }
        this.loader = false
      })
  }


  filtraDati(mkt: string | undefined, giorno: string | undefined, ora: number | undefined, pattern: string | undefined, minNumOp: number | undefined) {
    if (!this.listaCompleta) { return [] }
    let lst: Array<any> = this.listaCompleta
    if (window.location.hostname.indexOf('localhost') < 0) {
      mkt = mkt?.toLocaleLowerCase()
    }
    mkt = mkt?.toLocaleLowerCase()
    if (mkt != 'Tutti') {
      lst = lst.filter(item => {
        return item['market'] == mkt
      }, mkt)
    }
    if (giorno != null && giorno != "Tutti") {
      lst = lst.filter(item => {
        return item['dayweek'] == giorno
      }, giorno)
    }
    if (ora) {
      if (ora > 0) {
        lst = lst.filter(item => {
          return item['orap'] == ora
        }, ora)
      }
    }
    if (pattern != '0' && pattern != 'Tutti') {
      lst = lst.filter(item => {
        return item['pattern'] == pattern
      }, pattern)
    } else if (ora && pattern == '0' && ora > 0) {
      console.log(pattern)
      let tmp = []
      for (let i = ora + 2; i < 23; i++) {
        let a = lst.filter((item) => {
          return item['oraclosep'] == i
        }, i)
        tmp.push(a)
      }
      lst = []
      tmp.forEach(item => {
        let stra = {
          orap: ora,
          oraclosep: item[0].oraclosep,
          numop: 0,
          puntiop: 0,
          rawal: 0,
          kelly: 0,
          percpos: 0,
          avgwin: 0,
          avgloss: 0,
          avghighpos: 0,
          avglowpos: 0,
          avghighneg: 0,
          avglowneg: 0
        }
        let sommawin = 0
        let sommaloss = 0
        let numwin = 0
        let numloss = 0
        let avghighpos = 0
        let avglowpos = 0
        let avghighneg = 0
        let avglowneg = 0
        for (let i = 0; i < item.length; i++) {
          stra.numop += +item[i].numop
          stra.puntiop += +item[i].punti
          sommawin += +item[i].avgwin * item[i].numpos
          sommaloss += +item[i].avgloss * item[i].numneg
          numwin += +item[i].numpos
          numloss += +item[i].numneg
          avghighpos += +item[i].avghighpos * item[i].numpos
          avghighneg += +item[i].avghighneg * item[i].numneg
          avglowpos += +item[i].avglowpos * item[i].numpos
          avglowneg += +item[i].avglowneg * item[i].numneg
        }
        stra.puntiop = stra.puntiop / stra.numop
        stra.rawal = -(sommawin / numwin) / (sommaloss / numloss)
        stra.percpos = numwin / (numwin + numloss)
        stra.kelly = ((stra.rawal + 1) * stra.percpos - 1) / stra.rawal
        stra.avgwin = sommawin / numwin
        stra.avgloss = sommaloss / numloss
        stra.avghighpos = avghighpos / numwin
        stra.avglowpos = avglowpos / numwin
        stra.avghighneg = avghighneg / numloss
        stra.avglowneg = avglowneg / numloss
        lst.push(stra)
      })

      console.log(lst)
    }
    if (giorno && ora && mkt != 'tutti' && parseInt(giorno) > 0 && ora > 0) {
      this.selMarket(mkt)
    }
    return lst
  }

  sortBy(by: string | any): void {
    let gg = this.weekDays.find(item => item.value == this.selGiorno.value, this.selGiorno.value)
    let lista: any = this.filtraDati(this.selMercato.value, (gg ? gg.value : undefined), this.selOrario.value, this.selPattern.value, this.selNumop.value)
    lista?.sort((a: any, b: any) => {
      if (by == 'numop' || by == 'puntiop' || by == 'orap' || by == 'oraclosep') {
        if (parseFloat(a[by]) < parseFloat(b[by])) {
          return this.sorted ? 1 : -1;
        }
        if (parseFloat(a[by]) > parseFloat(b[by])) {
          return this.sorted ? -1 : 1;
        }
      } else {
        if (a[by] < b[by]) {
          return this.sorted ? 1 : -1;
        }
        if (a[by] > b[by]) {
          return this.sorted ? -1 : 1;
        }
      }


      return 0;
    });
    this.tableData = lista.slice(0, 100)
    this.sorted = !this.sorted;
  }

}
